// Mock data for AKSUBEB website

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_video-study-build/artifacts/xvbdm7su_logo.jpeg",
  governor: "https://customer-assets.emergentagent.com/job_video-study-build/artifacts/6ieuoehm_WhatsApp%20Image%202026-05-17%20at%2010.01.10%20AM.jpeg",
  chairman: "https://customer-assets.emergentagent.com/job_video-study-build/artifacts/fi0cpp72_499196020_2174831292960592_6331174541859266834_n.jpg"
};

// Hero slider: 3 slides with Ken Burns zoom-in fade effect
// 1) Children in school (video) with play button overlay
// 2) Governor full image
// 3) Logo full image
export const heroSlides = [
  {
    id: 1,
    kind: "video",
    image: "https://images.unsplash.com/photo-1473649085228-583485e6e4d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    videoUrl: "https://www.youtube.com/embed/JqEjEh8X4Pg?autoplay=1",
    overlayText: "Infrastructure development"
  },
  {
    id: 2,
    kind: "full-image",
    image: ASSETS.governor,
    overlayText: ""
  },
  {
    id: 3,
    kind: "full-logo",
    image: ASSETS.logo,
    overlayText: ""
  }
];

export const stats = [
  { id: 1, value: 14250, label: "Qualified Teachers", icon: "users" },
  { id: 2, value: 412, label: "Completed Projects", icon: "check-circle" },
  { id: 3, value: 1325, label: "Schools", icon: "school" },
  { id: 4, value: 42, label: "Awards Winning", icon: "award" }
];

export const objectives = [
  "Providing free, Universal Basic Education for every Nigerian Child of School age in Akwa Ibom State.",
  "Developing in the entire citizenry a strong consciousness for education and a strong commitment to its vigorous promotion.",
  "Reducing drastically the incidence of drop-out from the formal school system.",
  "Ensuring the acquisition of appropriate level of literacy, numeracy, communicative and life skills.",
  "Preserving and complementing the existing educational structure, bodies and agencies for the purpose of realizing the Board’s mission; and carrying out the policy guidelines prescribed by Universal Basic Education Commission (UBEC) and other relevant agencies as approved by the State Government."
];

export const whatWeDo = [
  {
    id: 1,
    title: "Formulate Policy Guidelines",
    description: "Formulate the policy guidelines for the successful operation of the Universal Basic Education Programme in Akwa Ibom State.",
    icon: "file-text"
  },
  {
    id: 2,
    title: "Support State Capacity Building",
    description: "Support State Capacity Building for teachers and managers of basic education in the State.",
    icon: "graduation-cap"
  },
  {
    id: 3,
    title: "Co-ordinate Teaching & Learning",
    description: "Co-ordinate and supervise teaching and learning in Public Primary Schools and Junior Secondary Schools in the State.",
    icon: "book-open"
  }
];

export const newsBlog = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1627423896085-e3e694d88e40?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Gov. Eno Releases ₦5.9 Billion for Basic Education Reforms",
    date: "May 14, 2026",
    excerpt: "Rt. Hon. Dr. Anietie Etuk announced the release of ₦5.9 billion by Governor Pastor Umo Eno for 2025 and 2026 intervention projects across Akwa Ibom State.",
    slug: "gov-eno-5-9-billion"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1473649085228-583485e6e4d7?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Commissioning of Renovated Classrooms in Ikot Ekpene",
    date: "April 22, 2026",
    excerpt: "Governor Pastor Umo Eno live at the commissioning of newly renovated classroom blocks at Community Primary School, Ikot Ekpene.",
    slug: "commissioning-of-projects"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1536337005238-94b997371b40?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "AKSUBEB Seeks Stakeholders’ Collaboration On Improved Basic Education",
    date: "March 18, 2026",
    excerpt: "The Chairman of AKSUBEB has solicited partnership of National Parents Teachers Association of Nigeria (NAPTAN) and other stakeholders in the education sector.",
    slug: "stakeholders-collaboration"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1667844141324-61585c18b0df?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Training of STEM Teachers Across 31 LGAs",
    date: "February 09, 2026",
    excerpt: "AKSUBEB trains STEM Teachers across the 31 Local Government Areas of Akwa Ibom State to deliver world-class basic education.",
    slug: "training-of-stem-teachers"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1632215861513-130b66fe97f4?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Free Education: Akwa Ibom Calls For Increased Public-School Enrollment",
    date: "January 28, 2026",
    excerpt: "The Akwa Ibom State Government is calling on parents to take advantage of the free basic education policy and enroll their children in public schools.",
    slug: "free-education-enrollment"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1620969910995-4bbe4eaa32c1?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "SUBEB Hands Over Administrative Block to Etinan Council",
    date: "December 12, 2025",
    excerpt: "AKSUBEB officially hands over a newly built administrative block to Etinan Local Government Education Council as part of ongoing infrastructure rollout.",
    slug: "etinan-admin-block"
  }
];

export const chairman = {
  name: "Rt. Hon. Dr. Anietie Etuk",
  title: "Executive Chairman, AKSUBEB",
  image: ASSETS.chairman,
  message: [
    "Equitable and quality education remains a central pillar of the Global Sustainable Development Goals and a key priority under Governor Pastor Umo Eno’s ARISE Agenda.",
    
    "In line with this vision, the Akwa Ibom State Universal Basic Education Board shares in the responsibility of ensuring that every child in the state has access to quality basic education.",
    
    "We are committed to delivering basic education that meets global standards for children of school-going age in Akwa Ibom State, regardless of their economic background, physical condition, or social circumstance. This commitment includes the strategic use of technology to improve learning outcomes and prepare pupils for a rapidly changing world.",
    
    "We believe every child has the right to sound knowledge and relevant skills. These skills should enable them to make informed decisions, live responsibly, think creatively, solve problems, and contribute meaningfully as better citizens.",
    
    "Governor Umo Eno has stated that his administration remains committed to ensuring that every Akwa Ibom child receives a strong basic educational foundation under the ARISE Agenda."
  ]
};

export const navigation = [
  { label: "Home", path: "/", children: [] },
  {
    label: "About us",
    path: "/about",
    children: [
      { label: "About AKSUBEB", path: "/about" },
      { label: "Governing Board", path: "/about" },
      { label: "Management Team", path: "/about" }
    ]
  },
  {
    label: "Departments",
    path: "/departments",
    children: [
      { label: "Executive Chairman Office", path: "/departments" },
      { label: "Planning Research & Statistics", path: "/departments" },
      { label: "Standard and Quality Assurance", path: "/departments" },
      { label: "Social Mobilization & ICT", path: "/departments" },
      { label: "School Services", path: "/departments" },
      { label: "Finance and Account", path: "/departments" },
      { label: "Administration and Supply", path: "/departments" },
      { label: "Personnel", path: "/departments" },
    ]
  },
  { label: "Programs", path: "/programs", children: [] },
  { label: "Projects", path: "/projects", children: [] },
  {
    label: "Media",
    path: "/media",
    children: [
      { label: "News", path: "/media" },
      { label: "Photo Gallery", path: "/media" },
      { label: "Video Gallery", path: "/media" },
      { label: "Downloads", path: "/media" }
    ]
  },
  { label: "Contact us", path: "/contact", children: [] }
];

export const footerInfo = {
  address: "Akwa Ibom State Universal Basic Education Board (AKSUBEB), Idongesit Nkanga Secretariat, Uyo 520101, Akwa Ibom State, Nigeria.",
  emails: ["info@subeb.ak.gov.ng", "aksubeb@akwaibomstate.gov.ng"],
  phones: ["+234 803 555 0142", "+234 818 906 1663"]
};